module.exports = __webpack_public_path__ + "img/BG_header_vins.f78ed9c5.jpg";